import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { AdminAuthService } from './services/admin-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  /** True when current route is under /admin; nav is shown only then (hidden on survey/intake). */
  isAdminRoute = false;
  /** True when server confirmed admin access; nav hidden when false. */
  showAdminNav = false;
  private sub?: Subscription;
  private authSub?: Subscription;

  constructor(
    private router: Router,
    private readonly adminAuth: AdminAuthService
  ) {}

  ngOnInit(): void {
    this.updateAdminRoute();
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.updateAdminRoute());
    this.authSub = this.adminAuth.adminAccessAllowed$.subscribe((allowed) => {
      this.showAdminNav = allowed;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.authSub?.unsubscribe();
  }

  private updateAdminRoute(): void {
    this.isAdminRoute = this.router.url.startsWith('/admin');
  }
}
